import { useEffect } from 'react';
import { useLoaderData, useNavigate } from 'react-router';

const ResendConfirmation = () => {
	const data: any = useLoaderData();
	const navigate = useNavigate();

	useEffect(() => {
		if (!data.error) navigate('/dashboard', { replace: true });
	}, [data]);

	if (data.error) {
		return <div>Sorry you cannot login at this time. Please contact support.</div>;
	}

	return <div>Please wait finishing login...</div>;
};

export default ResendConfirmation;
